import React from "react";

import AboutSection from '../components/AboutSection';
import OfficeLocationsCentersSection from "../components/OfficeLocationsCentersSection";
import CalculatorSection from "../components/CalculatorSection";

const AboutPage = () => {
  return (
    <>
      <AboutSection/>
      <CalculatorSection/>
      <OfficeLocationsCentersSection/>
    </>
  );
};

export default AboutPage;
